export default "__VITE_ASSET__BG4vJCPP__"